// material
import Geocoder from 'react-map-gl-geocoder';
import 'mapbox-gl/dist/mapbox-gl.css';
import 'react-map-gl-geocoder/dist/mapbox-gl-geocoder.css';

export default function MapControlGeocoder(props: any) {
  return <Geocoder {...props} />;
}
